module.exports = __webpack_public_path__ + "img/icn_location.45031e9a.svg";